module.exports = __webpack_public_path__ + "static/media/wg4024.1ebf9319.png";